// extracted by mini-css-extract-plugin
export default {"container":"SignatureViewer_container__+EIgi","deletionIcon":"SignatureViewer_deletionIcon__Ya05y","signatureImg":"SignatureViewer_signatureImg__VbrTJ"};